import {
  getAll,
  getPage,
  getDetail,
  getMyUserGroupAll,
  getClientPage,
  getMyUserGroupPage,
  changeBusinessUser,
  getTeamReport,
  getMyBusinessPage,
  cancel,
  confirmRecept,
  batchConfirmRecept,
  importOrders,
  getReport,
  audit,
  batchAudit,
  callBack,
  batchCallBack,
  refuseService,
  addToRemark,
  confirmServiceDatetime,
  batchConfirmServiceDatetime,
  callbackClient,
  confirmRefuseService,
  tchManualGenerateMonitoringServices
} from '@/api/monitoringserviceserv'

export default {
  state: {
    state_MonitoringService_GetAllResult: null,
    state_MonitoringService_GetPageResult: null,
    state_MonitoringService_GetDetailResult: null,
    state_MonitoringService_GetMyUserGroupAllResult: null,
    state_MonitoringService_GetClientPageResult: null,
    state_MonitoringService_GetMyUserGroupPageResult: null,
    state_MonitoringService_ChangeBusinessUserResult: null,
    state_MonitoringService_GetTeamReportResult: null,
    state_MonitoringService_GetMyBusinessPageResult: null,
    state_MonitoringService_CancelResult: null,
    state_MonitoringService_ConfirmReceptResult: null,
    state_MonitoringService_BatchConfirmReceptResult: null,
    state_MonitoringService_ImportOrdersResult: null,
    state_MonitoringService_GetReportResult: null,
    state_MonitoringService_AuditResult: null,
    state_MonitoringService_BatchAuditResult: null,
    state_MonitoringService_CallBackResult: null,
    state_MonitoringService_BatchCallBackResult: null,
    state_MonitoringService_RefuseServiceResult: null,
    state_MonitoringService_AddToRemarkResult: null,
    state_MonitoringService_ConfirmServiceDatetimeResult: null,
    state_MonitoringService_BatchConfirmServiceDatetimeResult: null,
    state_MonitoringService_CallbackClientResult: null,
    state_MonitoringService_ConfirmRefuseServiceResult: null,
    state_MonitoringService_TchManualGenerateMonitoringServicesResult: null
  },
  mutations: {
    SET_MONITORINGSERVICE_GETALL_RESULT: (state, rst) => {
      state.state_MonitoringService_GetAllResult = rst
    },
    SET_MONITORINGSERVICE_GETPAGE_RESULT: (state, rst) => {
      state.state_MonitoringService_GetPageResult = rst
    },
    SET_MONITORINGSERVICE_GETDETAIL_RESULT: (state, rst) => {
      state.state_MonitoringService_GetDetailResult = rst
    },
    SET_MONITORINGSERVICE_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_MonitoringService_GetMyUserGroupAllResult = rst
    },
    SET_MONITORINGSERVICE_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_MonitoringService_GetClientPageResult = rst
    },
    SET_MONITORINGSERVICE_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_MonitoringService_GetMyUserGroupPageResult = rst
    },
    SET_MONITORINGSERVICE_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_MonitoringService_ChangeBusinessUserResult = rst
    },
    SET_MONITORINGSERVICE_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_MonitoringService_GetTeamReportResult = rst
    },
    SET_MONITORINGSERVICE_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_MonitoringService_GetMyBusinessPageResult = rst
    },
    SET_MONITORINGSERVICE_CANCEL_RESULT: (state, rst) => {
      state.state_MonitoringService_CancelResult = rst
    },
    SET_MONITORINGSERVICE_CONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_MonitoringService_ConfirmReceptResult = rst
    },
    SET_MONITORINGSERVICE_BATCHCONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_MonitoringService_BatchConfirmReceptResult = rst
    },
    SET_MONITORINGSERVICE_IMPORTORDERS_RESULT: (state, rst) => {
      state.state_MonitoringService_ImportOrdersResult = rst
    },
    SET_MONITORINGSERVICE_GETREPORT_RESULT: (state, rst) => {
      state.state_MonitoringService_GetReportResult = rst
    },
    SET_MONITORINGSERVICE_AUDIT_RESULT: (state, rst) => {
      state.state_MonitoringService_AuditResult = rst
    },
    SET_MONITORINGSERVICE_BATCHAUDIT_RESULT: (state, rst) => {
      state.state_MonitoringService_BatchAuditResult = rst
    },
    SET_MONITORINGSERVICE_CALLBACK_RESULT: (state, rst) => {
      state.state_MonitoringService_CallBackResult = rst
    },
    SET_MONITORINGSERVICE_BATCHCALLBACK_RESULT: (state, rst) => {
      state.state_MonitoringService_BatchCallBackResult = rst
    },
    SET_MONITORINGSERVICE_REFUSESERVICE_RESULT: (state, rst) => {
      state.state_MonitoringService_RefuseServiceResult = rst
    },
    SET_MONITORINGSERVICE_ADDTOREMARK_RESULT: (state, rst) => {
      state.state_MonitoringService_AddToRemarkResult = rst
    },
    SET_MONITORINGSERVICE_CONFIRMSERVICEDATETIME_RESULT: (state, rst) => {
      state.state_MonitoringService_ConfirmServiceDatetimeResult = rst
    },
    SET_MONITORINGSERVICE_BATCHCONFIRMSERVICEDATETIME_RESULT: (state, rst) => {
      state.state_MonitoringService_BatchConfirmServiceDatetimeResult = rst
    },
    SET_MONITORINGSERVICE_CALLBACKCLIENT_RESULT: (state, rst) => {
      state.state_MonitoringService_CallbackClientResult = rst
    },
    SET_MONITORINGSERVICE_CONFIRMREFUSESERVICE_RESULT: (state, rst) => {
      state.state_MonitoringService_ConfirmRefuseServiceResult = rst
    },
    SET_MONITORINGSERVICE_TCHMANUALGENERATEMONITORINGSERVICES_RESULT: (state, rst) => {
      state.state_MonitoringService_TchManualGenerateMonitoringServicesResult = rst
    }
  },
  actions: {
    MonitoringServiceServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetClientPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETCLIENTPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETCLIENTPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_ChangeBusinessUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CHANGEBUSINESSUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CHANGEBUSINESSUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetTeamReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETTEAMREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETTEAMREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetMyBusinessPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETMYBUSINESSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETMYBUSINESSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_Cancel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CANCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CANCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_ConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_BatchConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchConfirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_BATCHCONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_BATCHCONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_ImportOrders ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        importOrders(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_IMPORTORDERS_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_IMPORTORDERS_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_GetReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_GETREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_GETREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_Audit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        audit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_AUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_AUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_BatchAudit ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAudit(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_BATCHAUDIT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_BATCHAUDIT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_CallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        callBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_BatchCallBack ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchCallBack(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_BATCHCALLBACK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_BATCHCALLBACK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_RefuseService ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        refuseService(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_REFUSESERVICE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_REFUSESERVICE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_AddToRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addToRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_ADDTOREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_ADDTOREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_ConfirmServiceDatetime ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmServiceDatetime(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CONFIRMSERVICEDATETIME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CONFIRMSERVICEDATETIME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_BatchConfirmServiceDatetime ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchConfirmServiceDatetime(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_BATCHCONFIRMSERVICEDATETIME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_BATCHCONFIRMSERVICEDATETIME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_CallbackClient ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        callbackClient(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CALLBACKCLIENT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CALLBACKCLIENT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_ConfirmRefuseService ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRefuseService(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_CONFIRMREFUSESERVICE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_CONFIRMREFUSESERVICE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoringServiceServ_TchManualGenerateMonitoringServices ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        tchManualGenerateMonitoringServices(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITORINGSERVICE_TCHMANUALGENERATEMONITORINGSERVICES_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITORINGSERVICE_TCHMANUALGENERATEMONITORINGSERVICES_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_MonitoringService_GetAllResult: state => {
      return state.state_MonitoringService_GetAllResult
    },
    get_MonitoringService_GetPageResult: state => {
      return state.state_MonitoringService_GetPageResult
    },
    get_MonitoringService_GetDetailResult: state => {
      return state.state_MonitoringService_GetDetailResult
    },
    get_MonitoringService_GetMyUserGroupAllResult: state => {
      return state.state_MonitoringService_GetMyUserGroupAllResult
    },
    get_MonitoringService_GetClientPageResult: state => {
      return state.state_MonitoringService_GetClientPageResult
    },
    get_MonitoringService_GetMyUserGroupPageResult: state => {
      return state.state_MonitoringService_GetMyUserGroupPageResult
    },
    get_MonitoringService_ChangeBusinessUserResult: state => {
      return state.state_MonitoringService_ChangeBusinessUserResult
    },
    get_MonitoringService_GetTeamReportResult: state => {
      return state.state_MonitoringService_GetTeamReportResult
    },
    get_MonitoringService_GetMyBusinessPageResult: state => {
      return state.state_MonitoringService_GetMyBusinessPageResult
    },
    get_MonitoringService_CancelResult: state => {
      return state.state_MonitoringService_CancelResult
    },
    get_MonitoringService_ConfirmReceptResult: state => {
      return state.state_MonitoringService_ConfirmReceptResult
    },
    get_MonitoringService_BatchConfirmReceptResult: state => {
      return state.state_MonitoringService_BatchConfirmReceptResult
    },
    get_MonitoringService_ImportOrdersResult: state => {
      return state.state_MonitoringService_ImportOrdersResult
    },
    get_MonitoringService_GetReportResult: state => {
      return state.state_MonitoringService_GetReportResult
    },
    get_MonitoringService_AuditResult: state => {
      return state.state_MonitoringService_AuditResult
    },
    get_MonitoringService_BatchAuditResult: state => {
      return state.state_MonitoringService_BatchAuditResult
    },
    get_MonitoringService_CallBackResult: state => {
      return state.state_MonitoringService_CallBackResult
    },
    get_MonitoringService_BatchCallBackResult: state => {
      return state.state_MonitoringService_BatchCallBackResult
    },
    get_MonitoringService_RefuseServiceResult: state => {
      return state.state_MonitoringService_RefuseServiceResult
    },
    get_MonitoringService_AddToRemarkResult: state => {
      return state.state_MonitoringService_AddToRemarkResult
    },
    get_MonitoringService_ConfirmServiceDatetimeResult: state => {
      return state.state_MonitoringService_ConfirmServiceDatetimeResult
    },
    get_MonitoringService_BatchConfirmServiceDatetimeResult: state => {
      return state.state_MonitoringService_BatchConfirmServiceDatetimeResult
    },
    get_MonitoringService_CallbackClientResult: state => {
      return state.state_MonitoringService_CallbackClientResult
    },
    get_MonitoringService_ConfirmRefuseServiceResult: state => {
      return state.state_MonitoringService_ConfirmRefuseServiceResult
    },
    get_MonitoringService_TchManualGenerateMonitoringServicesResult: state => {
      return state.state_MonitoringService_TchManualGenerateMonitoringServicesResult
    }
  }
}
